import { requireModule } from 'auth/guards';
import { MODULES } from 'auth/permissions';
import SalaryBoardPage from './pages/SalaryBoard';

export const payrollRoutes = [
  {
    path: '/salary-board',
    element: <SalaryBoardPage />,
    handle: { breadcrumb: 'Salary Board' },
    // Admin, HR and Accounts — the same list the sidebar entry has always used.
    loader: requireModule(MODULES.SALARY),
  },
];
